import { render } from "./AddIcon16.vue.js?vue&type=template&id=54690fda!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./AddIcon16.vue?vue&type=template&id=54690fda"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__